import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import '../styles/Login.css';
import obraswiseLogo from '../assets/obraswise-logo.png';
import { apiService } from '../services/ApiService';
import { useTheme } from '../contexts/ThemeContext';
import { FiSun, FiMoon } from 'react-icons/fi';

const RedefinirSenha = () => {
  const [loading, setLoading] = useState(false);
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [tokenValido, setTokenValido] = useState(true);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { darkMode, toggleTheme } = useTheme();
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      setTokenValido(false);
      setError('Token de recuperação não encontrado.');
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);

    // Validações
    if (novaSenha.length < 6) {
      setError('A senha deve ter pelo menos 6 caracteres.');
      return;
    }

    if (novaSenha !== confirmarSenha) {
      setError('As senhas não coincidem.');
      return;
    }

    setLoading(true);

    try {
      const result = await apiService.redefinirSenha(token, novaSenha);

      if (result.success) {
        setSuccess(true);
        // Redireciona para o login após 3 segundos
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      } else {
        setError(result.error || 'Ocorreu um erro ao redefinir a senha.');
        if (result.error?.includes('expirado')) {
          setTokenValido(false);
        }
      }
    } catch (error) {
      setError('Ocorreu um erro ao conectar com o servidor. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  if (!tokenValido) {
    return (
      <div className={`login-container ${!darkMode ? 'light-mode' : ''}`}>
        <div className="login-card">
          <div className="theme-toggle">
            <button 
              className="theme-button" 
              onClick={toggleTheme} 
              aria-label={darkMode ? "Mudar para tema claro" : "Mudar para tema escuro"}
            >
              {darkMode ? <FiSun /> : <FiMoon />}
            </button>
          </div>
          
          <div className="logo-container">
            <img src={obraswiseLogo} alt="Obraswise" className="logo" />
          </div>
          <h2 className="title">Link Inválido</h2>
          
          <div className="error-message">
            <p>O link de recuperação de senha é inválido ou expirou.</p>
            <p>Por favor, solicite um novo link de recuperação.</p>
          </div>
          
          <button 
            type="button" 
            className="login-button" 
            onClick={() => navigate('/login')}
          >
            Voltar para Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={`login-container ${!darkMode ? 'light-mode' : ''}`}>
      <div className="login-card">
        <div className="theme-toggle">
          <button 
            className="theme-button" 
            onClick={toggleTheme} 
            aria-label={darkMode ? "Mudar para tema claro" : "Mudar para tema escuro"}
          >
            {darkMode ? <FiSun /> : <FiMoon />}
          </button>
        </div>
        
        <div className="logo-container">
          <img src={obraswiseLogo} alt="Obraswise" className="logo" />
        </div>
        <h2 className="title">Redefinir Senha</h2>
        
        {success ? (
          <div className="success-message">
            <p>Sua senha foi redefinida com sucesso!</p>
            <p>Você será redirecionado para a página de login em instantes...</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="login-form">
            {error && <div className="error-message">{error}</div>}
            <div className="form-group">
              <label>Nova Senha</label>
              <input 
                type="password" 
                placeholder="Digite sua nova senha" 
                value={novaSenha}
                onChange={(e) => setNovaSenha(e.target.value)}
                required 
                disabled={loading}
              />
              <small className="help-text">A senha deve ter pelo menos 6 caracteres</small>
            </div>
            <div className="form-group">
              <label>Confirmar Nova Senha</label>
              <input 
                type="password" 
                placeholder="Confirme sua nova senha" 
                value={confirmarSenha}
                onChange={(e) => setConfirmarSenha(e.target.value)}
                required 
                disabled={loading}
              />
            </div>
            <button type="submit" className="login-button" disabled={loading}>
              Redefinir Senha
            </button>
            <button 
              type="button" 
              className="register-button" 
              onClick={() => navigate('/login')}
              disabled={loading}
            >
              Cancelar
            </button>
          </form>
        )}
        
        {loading && (
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p className="loading-text">Redefinindo sua senha...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default RedefinirSenha; 